import React from 'react';
import GaugeComponent from 'react-gauge-component';
import { rescueHtml } from '../Components/Tools.js';
import Logo from '../Img/Logo_projets&finances.png';

const Page7Evaluation_Operations = (props) => {
    const blue = '#069BD3';
    const greyChapter = '#DBDBDB';
    const greyclair = '#FAFAFA';
    const fontsize = (props.height*12/890);

    const FieldBoxLargeTop = ({label}) => (
        <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: greyChapter, width: 250, borderTopLeftRadius: 3, borderBottomLeftRadius: 3}}>
            <p style={{marginTop: (0-props.marge), fontSize: fontsize+2, lineHeight: 1.2}}>{label}</p>
        </div>
    );

    const ValueBoxLargeTop = ({value}) => (
        <div style={{flex: 1, height: '100%', padding: 8, backgroundColor: greyclair, borderTopRightRadius: 3, borderBottomRightRadius: 3}}>
            <p style={{marginTop: (0-props.marge), height: '100%', fontSize: fontsize+2, lineHeight: 1.2, whiteSpace: 'normal', wordWrap: 'break-word', overflowY: 'hidden'}}>{value || ''}</p>
        </div>
    );

    return (
        <div style={{width: '100%', height: '100%', display: 'flex', flexDirection: 'column', backgroundColor: 'white'}}>
            
            {/* Header */}
            <div style={{ display: 'flex', height: '20%' }}>
                <div style={{ flex: 0.6, display: 'flex', marginLeft: 10 }}>
                    {props.logo && (
                        <img style={{ maxHeight: props.height / 8, borderRadius: 5 }} src={props.logo} alt="Logo" />
                    )}
                </div>

                <div style={{ flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <p style={{ color: blue, fontSize: (fontsize + 10) }}>Évaluation</p>
                </div>

                <div style={{ flex: 0.6, display: 'flex', justifyContent: 'right', marginRight: 25 }}>
                    <p style={{ color: 'grey', fontSize: (fontsize + 4) }}>{props.operation.nom}</p>
                </div>
            </div>

            {/* Contenu - 60% */}
            <div style={{flex: 1, padding: '10px 15px', overflow: 'hidden', display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', gap: '10px'}}>
                
                {/* Ligne 1: Description des objectifs */}
                <div style={{display: 'flex', height: 140}}>
                    <FieldBoxLargeTop label="Description des objectifs" />
                    <ValueBoxLargeTop value={rescueHtml(props.operation.description_objectifs || '')} />
                </div>

                {/* Ligne 2: Niveau atteinte des objectifs avec jauge */}
                    <div style={{display: 'flex', height: 140}}>
                        <FieldBoxLargeTop label="Niveau atteinte des objectifs" />
                        <ValueBoxLargeTop value={rescueHtml(props.operation.niveau_atteinte_objectifs || '')} />
                    </div>

                {/* Ligne 3: Ajustement des objectifs */}
                <div style={{display: 'flex', height: 200}}>
                    <div style={{flex: 1, display: 'flex', height: 200}}>
                        <FieldBoxLargeTop label="Ajustement des objectifs" />
                        <ValueBoxLargeTop value={rescueHtml(props.operation.ajustement_objectifs || '')} />
                    </div>
                    
                    <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minWidth: 200, borderRadius: 3, height: 240, padding: '10px', overflow: 'hidden'}}>
                        <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', height: 230}}>
                            <GaugeComponent
                                type="radial"
                                arc={{
                                    width: 0.3,
                                    padding: 0.02,
                                    cornerRadius: 3,
                                    subArcs: [
                                        { limit: 1, color: '#FF0000' },
                                        { limit: 2, color: '#FF4D4D' },
                                        { limit: 3, color: '#FF6666' },
                                        { limit: 4, color: '#FFDB99' },
                                        { limit: 5, color: '#FFBF40' },
                                        { limit: 6, color: '#FFA500' },
                                        { limit: 7, color: '#CCBF33' },
                                        { limit: 8, color: '#99CC66' },
                                        { limit: 9, color: '#85C97A' },
                                        { limit: 10, color: '#59B44A' }
                                    ]
                                }}
                                pointer={{
                                    color: blue,
                                    length: 0.7,
                                    width: 20
                                }}
                                value={props.operation.note !== null && props.operation.note !== undefined ? props.operation.note : 0}
                                labels={{
                                    valueLabel: { style: { display: 'none' } }
                                }}
                                minValue={0}
                                maxValue={10}
                                style={{width: '100%', height: '100%'}}
                            />
                        </div>
                        
                        <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: -40}}>
                            <p style={{fontSize: fontsize+2, fontWeight: 'bold'}}>
                                {props.operation.note !== null && props.operation.note !== undefined ? props.operation.note : 0}
                            </p>
                            <p style={{marginLeft: 2, fontSize: fontsize+2}}> / 10</p>
                        </div>
                    </div>
                </div>

            </div>

            {/* Footer - 20% */}
            <div style={{padding: '5px 30px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', zIndex: 1, flexShrink: 0}}>
                <div>
                    <p style={{fontSize: fontsize, color: '#666'}}>
                        {props.date}
                    </p>
                </div>
                <p style={{fontSize: fontsize, color: '#8B8B8B'}}>page : {props.pagination} / {props.countPageTotal}</p>
                <div>
                    <img style={{objectFit: 'contain', height: 40, borderRadius: 6}} src={Logo} alt="Logo SF" />
                </div>
            </div>
        </div>
    );
};

export default Page7Evaluation_Operations;
